import {
  DELETE_CALENDAR_FAILURE,
  DELETE_CALENDAR_REQUEST,
  DELETE_CALENDAR_SUCCESS,
  GET_CALENDAR_PERIODS_FAILURE,
  GET_CALENDAR_PERIODS_REQUEST,
  GET_CALENDAR_PERIODS_SUCCESS,
  GET_CLIENTS_FAILURE,
  GET_CLIENTS_REQUEST,
  GET_CLIENTS_SUCCESS,
  GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_SUCCESS,
  GET_CLIENT_CALENDARS_FAILURE,
  GET_CLIENT_CALENDARS_REQUEST,
  GET_CLIENT_CALENDARS_SUCCESS,
  GET_CLIENT_CONTACTS_FAILURE,
  GET_CLIENT_CONTACTS_REQUEST,
  GET_CLIENT_CONTACTS_SUCCESS,
  GET_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE,
  GET_CLIENT_CONTRACT_CREDITS_REBATES_REQUEST,
  GET_CLIENT_CONTRACT_CREDITS_REBATES_SUCCESS,
  GET_CLIENT_CONTRACT_FAILURE,
  GET_CLIENT_CONTRACT_FEE_FAILURE,
  GET_CLIENT_CONTRACT_FEE_REQUEST,
  GET_CLIENT_CONTRACT_FEE_SUCCESS,
  GET_CLIENT_CONTRACT_REQUEST,
  GET_CLIENT_CONTRACT_SLA_FAILURE,
  GET_CLIENT_CONTRACT_SLA_REQUEST,
  GET_CLIENT_CONTRACT_SLA_SUCCESS,
  GET_CLIENT_CONTRACT_SUCCESS,
  GET_CLIENT_DETAILS_FAILURE,
  GET_CLIENT_DETAILS_REQUEST,
  GET_CLIENT_DETAILS_SUCCESS,
  GET_CLIENT_GENERAL_NOTES_FAILURE,
  GET_CLIENT_GENERAL_NOTES_REQUEST,
  GET_CLIENT_GENERAL_NOTES_SUCCESS,
  GET_CLIENT_HOMESALE_INFO_FAILURE,
  GET_CLIENT_HOMESALE_INFO_REQUEST,
  GET_CLIENT_HOMESALE_INFO_SUCCESS,
  GET_CLIENT_ISSUES_CHALLENGES_FAILURE,
  GET_CLIENT_ISSUES_CHALLENGES_REQUEST,
  GET_CLIENT_ISSUES_CHALLENGES_SUCCESS,
  GET_CLIENT_METADATA_SUCCESS,
  GET_CLIENT_POLICIES_IMPORTANT_NOTES_REQUEST,
  GET_CLIENT_POLICIES_IMPORTANT_NOTES_SUCCESS,
  GET_CLIENT_POLICY_NOTES_FAILURE,
  GET_CLIENT_POLICY_NOTES_REQUEST,
  GET_CLIENT_POLICY_NOTES_SUCCESS,
  GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_SUCCESS,
  GET_CLIENT_SPECIAL_PROCESS_CATEGORIES_SUCCESS,
  GET_CLIENT_SPECIAL_PROCESS_SUCCESS,
  GET_CLIENT_STATIC_BENEFITS_SUCCESS,
  GET_HOMESALE_CLOSING_COSTS_FAILURE,
  GET_HOMESALE_CLOSING_COSTS_REQUEST,
  GET_HOMESALE_CLOSING_COSTS_SUCCESS,
  GET_HOMESALE_ELIGIBLE_PROPERTIES_FAILURE,
  GET_HOMESALE_ELIGIBLE_PROPERTIES_REQUEST,
  GET_HOMESALE_ELIGIBLE_PROPERTIES_SUCCESS,
  GET_HOMESALE_GBO_INSPECTIONS_FAILURE,
  GET_HOMESALE_GBO_INSPECTIONS_REQUEST,
  GET_HOMESALE_GBO_INSPECTIONS_SUCCESS,
  GET_HOMESALE_HHG_PROCESS_FAILURE,
  GET_HOMESALE_HHG_PROCESS_REQUEST,
  GET_HOMESALE_HHG_PROCESS_SUCCESS,
  GET_INTERNAL_USERS_FAILURE,
  GET_INTERNAL_USERS_REQUEST,
  GET_INTERNAL_USERS_SUCCESS,
  GET_POLICIES_GENERAL_INFO_REQUEST,
  GET_POLICIES_GENERAL_INFO__FAILURE,
  GET_POLICIES_GENERAL_INFO__SUCCESS,
  POST_CLIENT_CALENDAR_FAILURE,
  POST_CLIENT_CALENDAR_REQUEST,
  POST_CLIENT_CALENDAR_SUCCESS,
  POST_CLIENT_COMMENT_SUCCESS,
  POST_GBO_INSPECTIONS_INITIALIZE_FAILURE,
  POST_GBO_INSPECTIONS_INITIALIZE_REQUEST,
  SET_CURRENT_CLIENT_ID,
  SET_LOADING_COMPLETE,
  UPDATE_CLIENT_CALENDAR_FAILURE,
  UPDATE_CLIENT_CALENDAR_REQUEST,
  UPDATE_CLIENT_CALENDAR_SUCCESS,
  UPDATE_CLIENT_COMMENT_SUCCESS,
  GET_CLIENT_COMMENTS_SUCCESS,
  UPDATE_PERIOD_FAILURE,
  UPDATE_PERIOD_REQUEST,
  UPDATE_PERIOD_SUCCESS,
  GET_PURPOSE_BUILT_FIELD_TEMPLATES_SUCCESS,
  GET_CLIENT_CUSTOM_FIELDS_SUCCESS,
  POST_CLIENT_CUSTOM_FIELD_SUCCESS,
  UPDATE_CLIENT_CUSTOM_FIELD_SUCCESS,
  DELETE_CLIENT_COMMENT_SUCCESS,
  GET_CLIENT_DIVISIONS_SUCCESS,
  POST_CLIENT_CONTACT_SUCCESS,
  UPDATE_CLIENT_CONTACT_SUCCESS,
  POST_CLIENT_RELO_POLICY_SUCCESS,
  GET_CLIENT_PREFERRED_VENDORS_SUCCESS,
  GET_PREBUILT_TRIGGERS_SUCCESS,
  POST_GBO_INSPECTIONS_INITIALIZE_SUCCESS,
  GET_CLIENT_ADDRESSES_BY_CLIENT_ID_SUCCESS,
  POST_CLIENT_ADDRESS_SUCCESS,
  UPDATE_CLIENT_ADDRESS_SUCCESS,
  DELETE_CLIENT_ADDRESS_SUCCESS,
  UPDATE_PURPOSE_BUILT_FIELD_TEMPLATE_SUCCESS,
  POST_PURPOSE_BUILT_FIELD_TEMPLATE_SUCCESS
} from './types';
import produce from 'immer';

import { SET_FOCUSED_TAB } from 'modules/intake/types';

import { cleanClientDetails, extractManagers, remapClients, sortById } from '../common/utils';

const initialState = {
  isLoading: false,
  isLoadingCalendars: false,
  isPublishingCalendar: false,
  isDeletingCalendar: false,
  clientPolicyNotesLoading: false,
  clientHomesaleGeneralInfoLoading: false,
  clients: null,
  purposeBuiltFieldTemplates: null,
  currentClientId: null,
  clientsInfo: {},
  clientContactsLoading: false,
  clientIssuesAndChallengesLoading: false,
  clientGeneralNotesLoading: false,
  clientContactLoading: false,
  clientContractsSLALoading: false,
  clientContractsFeesLoading: false,
  clientContractsCreditsAndRebatesLoading: false,
  clientSpecialProcessesLoading: false,
  clientPoliciesImportantNotesIsLoading: false,
  clientHomesaleEligiblePropertiesLoading: false,
  homesaleClosingCostsLoading: false,
  homesaleGboInspectionsLoading: false,
  homesaleHHGProcessesLoading: false,
  focusedClientTab: null,
  unmappedClients: null,
  managerOptions: null,
  internalUsers: null,
  metadata: null,
  staticBenefits: null,
  commentsAndNotesWithAttachments: [],
  prebuiltTriggers: []
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_CLIENT_ID:
      draft.currentClientId = action.response;
      break;

    case GET_INTERNAL_USERS_REQUEST:
    case GET_CLIENTS_REQUEST:
    case GET_CLIENT_DETAILS_REQUEST:
      draft.isLoading = true;
      break;

    case GET_CLIENT_CONTACTS_REQUEST:
      draft.clientContactsLoading = true;
      break;

    case GET_PURPOSE_BUILT_FIELD_TEMPLATES_SUCCESS:
    case POST_PURPOSE_BUILT_FIELD_TEMPLATE_SUCCESS:
    case UPDATE_PURPOSE_BUILT_FIELD_TEMPLATE_SUCCESS:
      draft.purposeBuiltFieldTemplates = action.response;
      break;

    case GET_PREBUILT_TRIGGERS_SUCCESS:
      draft.prebuiltTriggers = action.response;
      break;

    case GET_CLIENT_ISSUES_CHALLENGES_REQUEST:
      draft.clientIssuesAndChallengesLoading = true;
      break;

    case GET_CLIENT_GENERAL_NOTES_REQUEST:
      draft.clientGeneralNotesLoading = true;
      break;

    case GET_CLIENT_CONTRACT_REQUEST:
      draft.clientContractLoading = true;
      break;

    case GET_CLIENT_CONTRACT_SLA_REQUEST:
      draft.clientContractsSLALoading = true;
      break;

    case GET_CLIENT_CONTRACT_FEE_REQUEST:
      draft.clientContractsFeesLoading = true;
      break;

    case GET_CLIENT_CONTRACT_CREDITS_REBATES_REQUEST:
      draft.clientContractsCreditsAndRebatesLoading = true;
      break;

    case GET_INTERNAL_USERS_FAILURE:
    case GET_CLIENTS_FAILURE:
    case GET_CLIENT_DETAILS_FAILURE:
      draft.isLoading = false;
      break;

    case GET_CLIENT_CONTACTS_FAILURE:
      draft.clientContactsLoading = false;
      break;

    case GET_CLIENT_ISSUES_CHALLENGES_FAILURE:
      draft.clientIssuesAndChallengesLoading = false;
      break;

    case GET_CLIENT_GENERAL_NOTES_FAILURE:
      draft.clientGeneralNotesLoading = false;
      break;

    case GET_CLIENT_CONTRACT_FAILURE:
      draft.clientContractLoading = false;
      break;

    case GET_CLIENT_CONTRACT_SLA_FAILURE:
      draft.clientContractsSLALoading = false;
      break;

    case GET_CLIENT_CONTRACT_FEE_FAILURE:
      draft.clientContractsFeesLoading = false;
      break;

    case GET_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE:
      draft.clientContractsCreditsAndRebatesLoading = false;
      break;

    case GET_CLIENTS_SUCCESS:
      draft.clients = remapClients(action.response);
      draft.unmappedClients = sortById(action.response);
      draft.managerOptions = extractManagers(action.response);
      draft.isLoading = false;
      break;

    case GET_CLIENT_DETAILS_SUCCESS:
      if (!draft.clientsInfo[draft.currentClientId]) draft.clientsInfo[draft.currentClientId] = {};
      draft.clientsInfo[draft.currentClientId].clientDetails = {
        ...cleanClientDetails(action.response),
        clientContract: draft.clientContract
      };
      draft.isLoading = false;
      break;

    case GET_CLIENT_CONTACTS_SUCCESS:
    case POST_CLIENT_CONTACT_SUCCESS:
    case UPDATE_CLIENT_CONTACT_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientDetails.clientContacts = action.response;
      break;

    case GET_CLIENT_DIVISIONS_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientDetails.clientDivisions = action.response;
      break;

    case GET_CLIENT_ADDRESSES_BY_CLIENT_ID_SUCCESS:
    case POST_CLIENT_ADDRESS_SUCCESS:
    case UPDATE_CLIENT_ADDRESS_SUCCESS:
    case DELETE_CLIENT_ADDRESS_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientDetails.clientAddresses = action.response;
      break;

    case GET_CLIENT_COMMENTS_SUCCESS:
    case POST_CLIENT_COMMENT_SUCCESS:
    case UPDATE_CLIENT_COMMENT_SUCCESS:
    case DELETE_CLIENT_COMMENT_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientDetails.clientComments = action.response;
      break;

    case GET_CLIENT_CUSTOM_FIELDS_SUCCESS:
    case POST_CLIENT_CUSTOM_FIELD_SUCCESS:
    case UPDATE_CLIENT_CUSTOM_FIELD_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientDetails.clientCustomFields = action.response;
      break;

    case GET_CLIENT_ISSUES_CHALLENGES_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientIssuesAndChallenges = action.response;
      draft.clientIssuesAndChallengesLoading = false;
      break;

    case GET_CLIENT_GENERAL_NOTES_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientGeneralNotes = action.response;
      draft.clientGeneralNotesLoading = false;
      break;

    case GET_CLIENT_CONTRACT_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientContract = action.response;
      draft.clientContractLoading = false;
      break;

    case GET_CLIENT_CONTRACT_SLA_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientDetails.clientSLAs = action.response;
      draft.clientContractsSLALoading = false;
      break;

    case GET_CLIENT_CONTRACT_FEE_SUCCESS:
      if (!draft.clientsInfo[action.context.clientId]) draft.clientsInfo[action.context.clientId] = {};
      draft.clientsInfo[action.context.clientId].clientContractsFees = action.response;
      if (!draft.clientsInfo[action.context.clientId]) draft.clientsInfo[action.context.clientId] = {};
      draft.clientsInfo[action.context.clientId].clientContractsFees = action.response;
      draft.clientContractsFeesLoading = false;
      break;

    case GET_CLIENT_CONTRACT_CREDITS_REBATES_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientDetails.clientCreditRebates = action.response;
      draft.clientContractsCreditsAndRebatesLoading = false;
      break;

    case SET_FOCUSED_TAB:
      draft.focusedClientTab = action.response;
      break;

    case GET_INTERNAL_USERS_SUCCESS:
      draft.internalUsers = action.response;
      draft.isLoading = false;
      break;

    case GET_CLIENT_SPECIAL_PROCESS_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientSpecialProcesses = action.response;
      draft.clientSpecialProcessesLoading = false;
      break;

    case GET_CLIENT_SPECIAL_PROCESS_CATEGORIES_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientSpecialProcessCategories = action.response;
      break;

    case GET_CLIENT_POLICIES_IMPORTANT_NOTES_REQUEST:
      draft.clientPoliciesImportantNotesIsLoading = true;
      break;

    case GET_CLIENT_POLICIES_IMPORTANT_NOTES_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientPoliciesImportantNotes = action.response;
      draft.clientPoliciesImportantNotesIsLoading = false;
      break;

    case DELETE_CALENDAR_REQUEST:
      draft.isDeletingCalendar = true;
      break;

    case DELETE_CALENDAR_SUCCESS:
    case DELETE_CALENDAR_FAILURE:
      draft.isDeletingCalendar = false;
      break;

    case POST_CLIENT_CALENDAR_REQUEST:
      draft.isPublishingCalendar = true;
      break;

    case POST_CLIENT_CALENDAR_SUCCESS:
    case POST_CLIENT_CALENDAR_FAILURE:
      draft.isPublishingCalendar = false;
      break;

    case UPDATE_PERIOD_REQUEST:
    case UPDATE_CLIENT_CALENDAR_REQUEST:
    case GET_CLIENT_CALENDARS_REQUEST:
    case GET_CALENDAR_PERIODS_REQUEST:
      draft.isLoadingCalendars = true;
      break;

    case UPDATE_PERIOD_FAILURE:
    case UPDATE_PERIOD_SUCCESS:
    case UPDATE_CLIENT_CALENDAR_FAILURE:
    case UPDATE_CLIENT_CALENDAR_SUCCESS:
    case GET_CLIENT_CALENDARS_FAILURE:
    case GET_CALENDAR_PERIODS_FAILURE:
      draft.isLoadingCalendars = false;
      break;

    case GET_CLIENT_CALENDARS_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientCalendars = action.response;
      draft.isLoadingCalendars = false;
      break;

    case GET_CLIENT_POLICY_NOTES_REQUEST:
      draft.clientPolicyNotesLoading = true;
      break;

    case GET_CLIENT_POLICY_NOTES_FAILURE:
      draft.clientPolicyNotesLoading = false;
      break;

    case GET_CLIENT_POLICY_NOTES_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientPolicyNotes = action.response;
      draft.clientPolicyNotesLoading = false;
      break;

    case GET_CALENDAR_PERIODS_SUCCESS:
      draft.clientsInfo[draft.currentClientId].calendarPeriods = action.response.clientPayrollPeriods;
      draft.isLoadingCalendars = false;
      break;

    case GET_CLIENT_HOMESALE_INFO_REQUEST:
      draft.clientHomesaleGeneralInfoLoading = true;
      break;

    case GET_CLIENT_HOMESALE_INFO_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientHomesaleGeneralInfo = action.response;
      draft.clientHomesaleGeneralInfoLoading = false;
      break;

    case GET_CLIENT_HOMESALE_INFO_FAILURE:
      draft.clientHomesaleGeneralInfoLoading = false;
      break;

    case GET_HOMESALE_ELIGIBLE_PROPERTIES_REQUEST:
      draft.clientHomesaleEligiblePropertiesLoading = true;
      break;

    case GET_HOMESALE_ELIGIBLE_PROPERTIES_FAILURE:
      draft.clientHomesaleEligiblePropertiesLoading = false;
      break;

    case GET_HOMESALE_ELIGIBLE_PROPERTIES_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientHomesaleEligibleProperties = action.response;
      draft.clientHomesaleEligiblePropertiesLoading = false;
      break;

    case GET_HOMESALE_CLOSING_COSTS_REQUEST:
      draft.homesaleClosingCostsLoading = true;
      break;

    case GET_HOMESALE_CLOSING_COSTS_FAILURE:
      draft.homesaleClosingCostsLoading = false;
      break;

    case GET_HOMESALE_CLOSING_COSTS_SUCCESS:
      draft.clientsInfo[draft.currentClientId].homesaleClosingCosts = action.response;
      draft.homesaleClosingCostsLoading = false;
      break;

    case GET_HOMESALE_GBO_INSPECTIONS_REQUEST:
      draft.homesaleGboInspectionsLoading = true;
      break;

    case GET_HOMESALE_GBO_INSPECTIONS_FAILURE:
      draft.homesaleGboInspectionsLoading = false;
      break;

    case GET_HOMESALE_GBO_INSPECTIONS_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientHomesaleGboInspections = action.response;
      draft.homesaleGboInspectionsLoading = false;
      break;

    case GET_POLICIES_GENERAL_INFO_REQUEST:
      draft.policiesGeneralInfoLoading = true;
      break;

    case GET_POLICIES_GENERAL_INFO__FAILURE:
      draft.policiesGeneralInfoLoading = false;
      break;

    case GET_POLICIES_GENERAL_INFO__SUCCESS:
      draft.clientsInfo[draft.currentClientId].policiesGeneralInfo = action.response;
      draft.policiesGeneralInfoLoading = false;
      break;

    case GET_CLIENT_METADATA_SUCCESS:
      draft.metadata = action.response;
      break;

    case POST_GBO_INSPECTIONS_INITIALIZE_REQUEST:
      draft.homesaleGboInspectionsLoading = true;
      break;

    case POST_GBO_INSPECTIONS_INITIALIZE_SUCCESS:
      draft.homesaleGboInspectionsLoading = false;
      break;

    case POST_GBO_INSPECTIONS_INITIALIZE_FAILURE:
      draft.homesaleGboInspectionsLoading = false;
      break;

    case GET_HOMESALE_HHG_PROCESS_REQUEST:
      draft.homesaleHHGProcessesLoading = true;
      break;

    case GET_HOMESALE_HHG_PROCESS_FAILURE:
      draft.homesaleHHGProcessesLoading = false;
      break;

    case GET_HOMESALE_HHG_PROCESS_SUCCESS:
      draft.clientsInfo[draft.currentClientId].homesaleHHGProcesses = action.response;
      draft.homesaleHHGProcessesLoading = false;
      break;

    case SET_LOADING_COMPLETE:
      draft.isLoading = false;
      break;

    // case POST_CLIENT_FEE_SUCCESS:
    //   const billingPolicyIndexP = draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies.findIndex(
    //     cbp => cbp.billingPolicy.billingPolicyId === action.payload.clientBillingPolicyId
    //   );
    //   draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies[billingPolicyIndexP].fees = action.response;
    //   break;

    // case UPDATE_CLIENT_FEE_SUCCESS:
    //   const billingPolicyIndexU = draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies.findIndex(
    //     cbp => cbp.billingPolicy.billingPolicyId === action.payload.clientBillingPolicyId
    //   );
    //   draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies[billingPolicyIndexU].fees = action.response;
    //   break;

    // case DELETE_CLIENT_FEE_SUCCESS:
    //   const billingPolicyIndexD = draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies.findIndex(
    //     cbp => cbp.billingPolicy.billingPolicyId === action.context.clientBillingPolicyId
    //   );
    //   draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies[billingPolicyIndexD].fees = action.response;
    //   break;

    case GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies = action.response;
      break;

    case GET_CLIENT_STATIC_BENEFITS_SUCCESS:
      draft.staticBenefits = action.response;
      break;

    case GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_SUCCESS:
    case POST_CLIENT_RELO_POLICY_SUCCESS:
      // case UPDATE_CLIENT_RELO_POLICY_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientDetails.clientRelocationPolicies = action.response;
      break;

    case GET_CLIENT_PREFERRED_VENDORS_SUCCESS:
      draft.clientsInfo[draft.currentClientId].clientDetails.clientPreferredVendors = action.response;
      draft.clientsInfo[draft.currentClientId].clientDetails.clientVendorRelationships = action.response;
      break;

    // case POST_CLIENT_FEE_SUCCESS:
    //   const billingPolicyIndexP = draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies.findIndex(
    //     cbp => cbp.billingPolicy.billingPolicyId === action.payload.clientBillingPolicyId
    //   );
    //   draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies[billingPolicyIndexP].fees = action.response;
    //   break;

    // case UPDATE_CLIENT_FEE_SUCCESS:
    //   const billingPolicyIndexU = draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies.findIndex(
    //     cbp => cbp.billingPolicy.billingPolicyId === action.payload.clientBillingPolicyId
    //   );
    //   draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies[billingPolicyIndexU].fees = action.response;
    //   break;

    // case DELETE_CLIENT_FEE_SUCCESS:
    //   const billingPolicyIndexD = draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies.findIndex(
    //     cbp => cbp.billingPolicy.billingPolicyId === action.context.clientBillingPolicyId
    //   );
    //   draft.clientsInfo[draft.currentClientId].clientDetails.clientBillingPolicies[billingPolicyIndexD].fees = action.response;
    //   break;

    default:
      break;
  }

  return draft;
}, initialState);
